module.exports = __webpack_public_path__ + "img/skin_dress_flyer_back.a5773a8f.jpg";